import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../constants/Url';
import { useTranslation } from 'react-i18next';
import BackHome from '../components/BackHome';
import { Card, Image, Skeleton } from 'antd';
import Meta from 'antd/es/card/Meta';

const ServicePage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true); // 👈 loading true first

    const seoungHangVIPData = [
        {
            title: "1-Offline and Online Delivery services local and internal to customers",
            description: <span style={{ fontSize: '1rem', color: "grey", fontWeight: 400, textAlign: "center" }}>We offer high quality in-store tailoring service.</span>,
            image: `${BASE_URL + "about-us/service.png"}`,
        },
        {
            title: "2-Tailoring Services for women and men (Business Partnership)",
            description: <span style={{ fontSize: '1rem', color: "grey", fontWeight: 400, textAlign: "center" }}>We offer high quality in-store tailoring service.</span>,
            image: `${BASE_URL + "about-us/service.jpg"}`,
        },
        {
            title: "3-Handwoven services and ordering for VIP customers.",
            description: <span style={{ fontSize: '1rem', color: "grey", fontWeight: 400, textAlign: "center" }}>We offer high quality in-store tailoring service.</span>,
            image: `${BASE_URL + "about-us/service1.jpg"}`,
        },
    ];

    // ⏳ setTimeout 1 minute (1000ms) to switch loading -> data
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false); // 🔥 stop loading after 1min
        }, 1000);

        return () => clearTimeout(timer); // Cleanup if unmount
    }, []);

    return (
        <div style={{ padding: "0px" }}>
            <BackHome title={t("Service")} t={t}/>
            <div className='esi-white-space'></div>

            <div className="p-3">
                <div className="esi-std-container pb-5">
                    <div className="esi-content-title">
                        {t("There are 3 Services")}
                        <div className="esi-secondary-line"></div>
                    </div>

                    <div className='esi-white-space'></div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
                        {/* 🧠 Important: Loading or Real Data */}
                        {loading ? (
                            Array(3).fill(0).map((_, index) => (
                                <div key={index} className='cursor-pointer select-none esi-news-card'>
                                    <div className='overflow-hidden max-sm:rounded-[1rem]'>
                                        <Skeleton.Image rootClassName='esi-news-card-image' className='esi-news-card-image' active={true} />
                                    </div>
                                    <div className='text-start w-full text-white md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[100%] mt-3 line-clamp-2'>
                                        <Skeleton.Input active block />
                                        <Skeleton.Input active block />
                                    </div>
                                </div>
                            ))
                        ) : (
                            seoungHangVIPData.map((card, index) => (
                                <Card
                                    key={index}
                                    hoverable
                                    style={{ width: 420 }}
                                    cover={<Image alt={card.title} src={card.image} style={{ height: '250px', objectFit: 'cover' }} />}
                                >
                                    <div>
                                <h6 className='labelHeader18600'>{card.title}</h6>
                                <h6 className='labelHeader18700'>{card.description}</h6>
                            </div>
                                </Card>
                            ))
                        )}
                    </div>

                </div>
            </div>

            <div className='esi-white-space'></div>
        </div>
    );
};

export default ServicePage;
